export function useGlobSetting() {
  // 请求域名
  // @ts-ignore
  const baseUrl: string = process.env.NODE_ENV === 'development' ? 'http://192.168.0.66:9797' : 'https://api.v1.jxcbyun.com';


  // url前缀
  const urlPrefix: string = '/admin-api';

  // token名称
  const tokenKey: string = 'X-Token';

  // token前缀
  const tokenPrefix: string = '';

  // 图片地址
  const imageUrl: string = 'https://api.v1.jxcbyun.com/bgimg1/';

  /** 图片上传地址 */
  // const uploadUrl: string = baseUrl + urlPrefix + '/index/upload';
  const uploadUrl: string = 'https://api.v1.jxcbyun.com/api/index/upload';

  const sentryTempIds = ['FCuqS5NpQo5A6cL8lqLOWfcdNBRFb6qOFV2flO9Wh2o', '_g6bOGAzgVj1pE9TufOiW4UwhgrxC4UOsFpuTnninQM'];

  // 微信H5网页 Appid
  const wx_appid = 'wxd9a642271ea1bf8d';

  // 支付宝H5网页 Appid
  const ali_appid = '2021005125640933';

  return { baseUrl, urlPrefix, tokenKey, tokenPrefix, imageUrl, uploadUrl, sentryTempIds, wx_appid, ali_appid };
}
